<template>
  <div ref="container" style="display: contents" />
</template>
<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: "CustomScript",
  props: {
    html: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.renderHtml();
  },
  beforeUnmount() {
    this.clearContainer();
  },
  methods: {
    clearContainer() {
      const container = this.$refs.container as HTMLDivElement | undefined;
      if (!container) {
        return;
      }

      container.replaceChildren();
    },
    renderHtml() {
      const container = this.$refs.container as HTMLDivElement | undefined;
      if (!container || !this.html) {
        return;
      }

      this.clearContainer();

      const template = document.createElement("template");
      template.innerHTML = this.html;

      Array.from(template.content.childNodes).forEach((node) => {
        if (!(node instanceof HTMLScriptElement)) {
          container.appendChild(node);
          return;
        }

        const script = document.createElement("script");
        Array.from(node.attributes).forEach((attribute) => {
          script.setAttribute(attribute.name, attribute.value);
        });
        script.text = node.textContent || "";
        container.appendChild(script);
      });
    }
  },
  watch: {
    html() {
      this.renderHtml();
    }
  }
});
</script>
